import instance from "./base-url";

import { useMutation } from 'react-query';

//Login API
const validateLogin = async (payload) => await instance.post(`/login`, payload);


//Login Queries
export function useValidateLogin() {
    // console.log(instance);
    return useMutation(validateLogin);
}